import { render, staticRenderFns } from "./ispUnassignPppList.vue?vue&type=template&id=002743a7&"
import script from "./ispUnassignPppList.vue?vue&type=script&lang=js&"
export * from "./ispUnassignPppList.vue?vue&type=script&lang=js&"
import style0 from "./ispUnassignPppList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports